<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Materiais Padronizados</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Materiais Padronizados"
            api-url="material"
            report-title="Materiais Padronizados"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'materiaisPadronizados'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="nome_filter">Nome</label>
                  <input
                    type="text"
                    v-model="nome"
                    class="form-control"
                    name="nome_filter"
                  />
                </div>
                <div class="col-sm-8">
                  <label class="custom-font" for="descricao_filter"
                    >Descrição</label
                  >
                  <input
                    type="text"
                    v-model="descricao"
                    class="form-control"
                    name="descricao_filter"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="medida_filter">Medida</label>
                  <select
                    v-model="medida"
                    @change="consultar"
                    name="medida_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todas</option>
                    <option
                      v-for="i in medidas"
                      :key="i.codigo"
                      :value="i.codigo"
                    >
                      {{ i.nome }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="subgrupo_filter"
                    >SubGrupo</label
                  >
                  <select
                    v-model="subgrupo"
                    @change="consultar"
                    name="subgrupo_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option
                      v-for="i in subgrupos"
                      :key="i.codigo"
                      :value="i.codigo"
                    >
                      {{ i.nome }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label class="custom-font" for="grupo_filter">Grupo</label>
                  <select
                    v-model="grupo"
                    @change="consultar"
                    name="grupo_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option
                      v-for="i in grupos"
                      :key="i.codigo"
                      :value="i.codigo"
                    >
                      {{ i.nome }}
                    </option>
                  </select>
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'user_material_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'materiais-padronizados',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'nome',
          title: 'Nome',
          sortField: 'nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'descricao',
          title: 'Descrição',
          sortField: 'descricao',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'medida.nome',
          title: 'Medida',
          sortField: 'medida.nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ],
      medidas: [],
      subgrupos: [],
      grupos: []
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    const me = this
    request
      .get('materiais/lista-medidas')
      .then(resp => {
        if (resp.length === 0) return
        me.medidas = resp.data
      })
      .catch(resp => {
        console.log(resp)
      })

    request
      .get('materiais/listar-subgrupos')
      .then(resp => {
        if (resp.length === 0) return
        me.subgrupos = resp.data
      })
      .catch(resp => {
        console.log(resp)
      })

    request
      .get('materiais/listar-grupos')
      .then(resp => {
        if (resp.length === 0) return
        me.grupos = resp.data
      })
      .catch(resp => {
        console.log(resp)
      })
  },
  computed: {
    filtros() {
      const { nome, descricao, medida, subgrupo, grupo } = this
      return {
        nome,
        descricao,
        medida,
        subgrupo,
        grupo
      }
    },
    pagina: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { pagina } = materiaisPadronizados
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'materiaisPadronizados',
          value: value
        })
      }
    },
    nome: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { nome } = materiaisPadronizados.filtros

        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'materiaisPadronizados',
          value: value
        })
        this.resetPageStore()
      }
    },
    descricao: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { descricao } = materiaisPadronizados.filtros

        return descricao
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'materiaisPadronizados',
          value: value
        })
        this.resetPageStore()
      }
    },
    medida: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { medida } = materiaisPadronizados.filtros

        return medida
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'medida',
          collection: 'materiaisPadronizados',
          value: value
        })
        this.resetPageStore()
      }
    },
    subgrupo: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { subgrupo } = materiaisPadronizados.filtros

        return subgrupo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'subgrupo',
          collection: 'materiaisPadronizados',
          value: value
        })
        this.resetPageStore()
      }
    },
    grupo: {
      get() {
        const { materiaisPadronizados } = this.$store.state.vuetableState
        const { grupo } = materiaisPadronizados.filtros

        return grupo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'grupo',
          collection: 'materiaisPadronizados',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    editar(data) {
      const { codigo: id } = data
      this.$router.push({ name: 'user_material_save', params: { id } })
    },
    excluir(data) {
      const me = this
      const { codigo: id } = data

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`material/${id}`)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Item removido com sucesso')
            })
            .catch(error => {
              me.$toastr.e(
                'Houve uma falha ao tentar remover este item, por favor tente novamente mais tarde!'
              )
              console.log(error)
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.nome = ''
      this.descricao = ''
      this.medida = ''
      this.subgrupo = ''
      this.grupo = ''

      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'materiaisPadronizados',
        value: 1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/materiais-padronizados/index.vue